export default function progressBar() {
  return {
    _id: false,
    type: 'droplet.progressBar',
    mediaQueries: [],
    pageCSS: '',
    progress: 50,
    total: 100,
    endText: 'Completed',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/progress-bar/droplet.schema.js